import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';

import { withinBettingContext } from 'app/contexts/betting';
import { Breadcrumb, MatchTable } from 'app/modules/Betting';

import { gridSubheaderBreadcrumbSelector } from '../../selectors/gridPresentation';

const createMapStateToProps = (state, { matchIds }) => {
  return {
    subheaderComponent: Breadcrumb,
    breadcrumbs: gridSubheaderBreadcrumbSelector(state, [...matchIds][0]),
  };
};

export default compose(
  withinBettingContext,
  connect(createMapStateToProps),
)(MatchTable);
